export const eventBus = new Vue();
import Vue from 'vue';
import VueRouter from 'vue-router';
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import Notifications from 'vue-notification';
import 'vue-loading-overlay/dist/vue-loading.css';

import App from './App.vue';
import router from './routing';
import store from './store';
import filters from '@/shared/filters';
import directives from '@/shared/directives';
import validatesExtend from '@/shared/validates-extension';

// import './registerServiceWorker';


import '@/styles/app.style.scss';


Vue.config.productionTip = false;

// Validate
for (const rule in rules) {
  extend(rule, {
    ...rules[rule],
  });
}

for (const rule in validatesExtend) {
  extend(rule, {
    ...validatesExtend[rule],
  });
}

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
// End Validate

// Filter
for (const filter in filters) {
  Vue.filter(filter, filters[filter]);
}
// End Filter

// Init Directive
for (const directive in directives) {
  Vue.directive(directive, directives[directive]);
}
// End Directive


// Notify
Vue.use(Notifications);
// End Notify


Vue.use(VueRouter);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
